import SoftBox from "components/SoftBox";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import { useUsersList } from "queries/users";
import { useState, useEffect } from "react";
import EditModal from "../../EditModal";
import DelModal from "../../DelModal";
import { useAgencyInfo } from "context/agency";

export default function dataTableData(search = "") {
  const request = useRequest();
  const [agency] = useAgencyInfo();
  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);

  // Reset to page 1 whenever the search term changes, matching the previous
  // manual-fetch behaviour of always refetching page 1 on a new search.
  useEffect(() => {
    setPage(1);
  }, [search]);

  // promptslabel is another fork's domain (queries/promptLabels.js) - inlined
  // here via useRequest() rather than centralized.
  const { data: tagsoption = [] } = useQuery({
    queryKey: ["prompt-labels", agency?._id],
    queryFn: async () => {
      const [{ response: respAgency }, { response: respAdmin }] = await Promise.all([
        request(ReqMethods.GET, "/promptslabel", {
          query: `type=agency&agency_id=${agency._id}`,
        }),
        request(ReqMethods.GET, "/promptslabel", {
          query: `type=super-admin&agency_id=superYxadminagency_id`,
        }),
      ]);
      return [...(respAgency?.data || []), ...(respAdmin?.data || [])];
    },
    enabled: !!agency?._id,
  });

  const { data: List = {}, isLoading: loader } = useUsersList({
    agencyId: agency?._id,
    page,
    search,
  });

  const accounts = (List.accounts || []).map((account) => ({
    ...account,
    label: account?.business_name,
    value: `${account.id}`,
  }));

  const handleRefresh = () => queryClient.invalidateQueries({ queryKey: ["users"] });

  const tableHeaders = ["User Name", "Email", "Tags", "Action"];
  const tableRows = [];

  for (let i = 0; i < List.records?.length; i++) {
    const data = List?.records?.[i];
    tableRows.push({
      user_name: data.userName,
      email: data.email,
      tags: (
        <SoftBox key={data._id}>
          {data.prompt_label_ids.map((item, index) => (
            <span key={index} className="alert-default-new" style={{ marginRight: "10px" }}>
              {item.name}
            </span>
          ))}
        </SoftBox>
      ),
      action: (
        <SoftBox key={data._id}>
          <EditModal
            accounts={accounts}
            data={data}
            handleRefresh={handleRefresh}
            tagsoption={tagsoption}
          />
          <DelModal accounts={accounts} data={data} handleRefresh={handleRefresh} />
        </SoftBox>
      ),
    });
  }

  return {
    loader: loader,
    accounts: accounts,
    handleRefresh: handleRefresh,
    page,
    setPage,
    dataTableData: {
      columns: tableHeaders.map((header) => ({
        Header: header,
        accessor: header.toLowerCase().replace(" ", "_"),
      })),
      rows: tableRows,
      page: List.page,
      limit: List.limit,
      totalpage: List.totalPages,
    },
  };
}
